import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const Compensation = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="69"
    height="59.071"
    viewBox="0 0 69 59.071"
  >
    <g transform="translate(-1049.755 -627)">
      <path
        d="M63,288v30H0V288Zm0,0"
        transform="translate(1049.755 339)"
        fill="#70b48f"
      />
      <path
        d="M95,320v30H32V320Zm0,0"
        transform="translate(1023.755 313)"
        fill="#599072"
      />
      <path
        d="M67,370v-3H64V355h3v-3h45v3h3v12h-3v3Zm0,0"
        transform="translate(997.755 287)"
        fill="#70b48f"
      />
      <ellipse
        cx="9"
        cy="9"
        rx="9"
        ry="9"
        transform="translate(1078.255 639)"
        fill="#599072"
      />
      <path
        d="M105.163,45.766l-10.794-7.2A14.3,14.3,0,0,1,88,26.67V7.151h.534a22.889,22.889,0,0,0,16.181-6.7L105.163,0"
        transform="translate(982.058 640.304)"
        fill="#bab8b9"
      />
      <path
        d="M102.44,38.507l-9.082-6.054A12.035,12.035,0,0,1,88,22.44V6.016h.449A19.259,19.259,0,0,0,102.064.377L102.44,0"
        transform="translate(984.781 643.934)"
        fill="#454855"
      />
      <path
        d="M184,0l.449.449a22.883,22.883,0,0,0,16.18,6.7h.534v19.52a14.3,14.3,0,0,1-6.369,11.9L184,45.767"
        transform="translate(903.221 640.304)"
        fill="#999"
      />
      <path
        d="M184,0l.378.378a19.254,19.254,0,0,0,13.614,5.639h.449V22.44a12.035,12.035,0,0,1-5.359,10.013L184,38.507"
        transform="translate(903.221 643.933)"
        fill="#272b34"
      />
      <path
        d="M7.251,33.083,2.79,28.589,1,30.392l6.251,6.3L18.962,24.893l-1.79-1.8Z"
        transform="translate(1077.639 633.648)"
        fill="#fc0"
      />
    </g>
  </Icon>
);

export default Compensation;



// WEBPACK FOOTER //
// ./src/components/Icons/Compensation.js